import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "login login-container"
}
const _hoisted_2 = { class: "login__title" }
const _hoisted_3 = { class: "text-white font-size-24 font-bold text-center" }
const _hoisted_4 = { class: "form" }
const _hoisted_5 = { class: "inputs" }
const _hoisted_6 = { class: "inputs-row mt-2" }
const _hoisted_7 = { class: "inputs-row mt-6" }
const _hoisted_8 = {
  key: 0,
  class: "mt-2 text-center text-sm text-red-500"
}
const _hoisted_9 = { class: "misc flex justify-end" }
const _hoisted_10 = { class: "submit" }
const _hoisted_11 = { class: "button" }
const _hoisted_12 = { class: "notice" }
const _hoisted_13 = {
  href: "/not-found",
  target: "_blank"
}
const _hoisted_14 = /*#__PURE__*/_createTextVNode("・ ")
const _hoisted_15 = {
  href: "/not-found",
  target: "_blank"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Input = _resolveComponent("Input")
  const _component_GradationButton = _resolveComponent("GradationButton")
  const _component_ToastApp = _resolveComponent("ToastApp")

  return (_openBlock(), _createBlock(_Fragment, null, [
    (_ctx.showLogin)
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            _createVNode("p", _hoisted_3, _toDisplayString(_ctx.t('loginPage.systemLogin')), 1)
          ]),
          _createVNode("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, [
              _createVNode("div", _hoisted_6, [
                _createVNode(_component_Input, {
                  classes: { 'input-invalid': _ctx.isSubmit && !_ctx.id },
                  class: "input",
                  placeholder: _ctx.t('loginPage.id'),
                  modelValue: _ctx.id,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.id = $event)),
                  disabled: _ctx.loading,
                  onKeyup: _withKeys(_ctx.login, ["enter"])
                }, null, 8, ["classes", "placeholder", "modelValue", "disabled", "onKeyup"])
              ]),
              _createVNode("div", _hoisted_7, [
                _createVNode(_component_Input, {
                  type: _ctx.passwordLogin.passwordFieldType,
                  class: "input",
                  placeholder: _ctx.t('loginPage.password'),
                  modelValue: _ctx.passwordLogin.password,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.passwordLogin.password = $event)),
                  "icon-password": true,
                  onOnshowPassword: _ctx.showPasswordLogin,
                  classes: { 'input-invalid': _ctx.isSubmit && !_ctx.passwordLogin.password },
                  disabled: _ctx.loading,
                  onKeyup: _withKeys(_ctx.login, ["enter"])
                }, null, 8, ["type", "placeholder", "modelValue", "onOnshowPassword", "classes", "disabled", "onKeyup"])
              ]),
              (_ctx.loginFailState)
                ? (_openBlock(), _createBlock("div", _hoisted_8, _toDisplayString(_ctx.t('loginPage.loginFail')), 1))
                : _createCommentVNode("", true),
              _createVNode("div", _hoisted_9, [
                _createVNode("a", {
                  class: "text-blue-517 cursor-pointer",
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.forgotPassword && _ctx.forgotPassword(...args)))
                }, _toDisplayString(_ctx.t('loginPage.forgetYourPassword')), 1)
              ])
            ]),
            _createVNode("div", _hoisted_10, [
              _createVNode("div", _hoisted_11, [
                _createVNode(_component_GradationButton, {
                  class: "login-button",
                  onClick: _ctx.login
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t('loginPage.login')), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _createVNode("div", _hoisted_12, [
                _createVNode("a", _hoisted_13, _toDisplayString(_ctx.t('loginPage.termsOfService')), 1),
                _hoisted_14,
                _createVNode("a", _hoisted_15, _toDisplayString(_ctx.t('loginPage.privacyPolicy')), 1),
                _createTextVNode(" " + _toDisplayString(_ctx.t('loginPage.agreeing')), 1)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_ToastApp)
  ], 64))
}